define("calendar/models/tiktok-post", ["exports", "@ember/object/computed", "@ember/utils", "@glimmer/tracking", "ember-api-actions", "later/utils/secure-url"], function (_exports, _computed, _utils, _tracking, _emberApiActions, _secureUrl) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _dec, _dec2, _class, _descriptor, _descriptor2, _descriptor3;

  0; //eaimeta@70e063a35619d71f0,"@ember/object/computed",0,"@ember/utils",0,"@glimmer/tracking",0,"ember-api-actions",0,"later/utils/secure-url"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  let TiktokPost = (_dec = (0, _computed.alias)('video_description'), _dec2 = (0, _computed.alias)('create_time'), (_class = class TiktokPost {
    /**
     * Constructs an instance a TikTok Post
     *
     * @method constructor
     * @param {Object} obj
     * @param {String} obj.cover_image_url
     * @param {Number} obj.create_time
     * @param {Number} obj.duration
     * @param {Number} obj.expire_time
     * @param {Number} obj.height
     * @param {String} obj.id
     * @param {String} obj.share_url
     * @param {String} obj.video_description
     * @param {Number} obj.width
     *
     * @returns TikTokPost instance
     */
    constructor(data) {
      _initializerDefineProperty(this, "caption", _descriptor, this);

      _initializerDefineProperty(this, "createTime", _descriptor2, this);

      _initializerDefineProperty(this, "linkinbioPost", _descriptor3, this);

      _defineProperty(this, "verify", (0, _emberApiActions.memberAction)({
        path: 'verify',
        type: 'post'
      }));

      Object.entries(data).forEach(_ref => {
        let [key, value] = _ref;
        this[key] = value;
      });
      this.isTiktokPost = true;
    }

    get createdMoment() {
      return moment(this.create_time * 1000);
    }

    get displayTime() {
      return parseInt(this.create_time);
    }

    formatCreatedTime(format) {
      return this.createdMoment.format(format);
    }

    get formattedTimeSinceCreated() {
      return moment(this.formatCreatedTime('ddd, MMM D YYYY LT')).fromNow();
    }

    get hasLinkinbioPost() {
      return !(0, _utils.isEmpty)(this.linkinbioPost);
    }

    get secureStandardResUrl() {
      return (0, _secureUrl.secureUrl)(this.cover_image_url);
    }

    get secureThumbUrl() {
      return (0, _secureUrl.secureUrl)(this.cover_image_url);
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "caption", [_dec], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "createTime", [_dec2], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "linkinbioPost", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return null;
    }
  })), _class));
  _exports.default = TiktokPost;
});